export default {
  copyToClipboard: 'Copy to Clipboard',
} as const;
